import { useEffect, useState } from 'react';
import { supabase } from '../../../../../utils/supabaseClient';

export function useCollection(collectionId) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let ignore = false;
    async function fetchData() {
      try {
        setLoading(true);
        setError(null);
        const { data, error } = await supabase
          .from('collections')
          .select('*')
          .eq('collection_id', collectionId)
          .single();
        if (!ignore) {
          if (error) throw error;
          setData(data);
        }
      } catch (e) {
        if (!ignore) setError(e);
      } finally {
        if (!ignore) setLoading(false);
      }
    }
    if (collectionId) fetchData();
    return () => { ignore = true; };
  }, [collectionId]);

  return { data, loading, error };
}
